import React, { Component } from "react";
import { withTranslation } from 'react-i18next';

class Footer extends Component {
  render() {
    const { t } = this.props;
    const year = new Date().getFullYear();

    return (
      <React.Fragment>
        <footer className="footer-area">
          <div className="footer-wrapper">
            <div className="row align-items-end row--0">
              <div className="col-lg-6">
                <div className="footer-left">
                  <div className="inner">
                    <span>{t("call to action-1")}</span>
                    <h2>
                      {t("call to action-2")}
                    </h2>
                    <a className="rn-button-style--2" href="/contact">
                      <span>{t("Contact button")}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="footer-right">
                  <div className="row">
                    {/* Start Single Widget  */}
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="footer-link">
                        <h4>{t("Acceso rapido")}</h4>
                        <ul className="ft-link">
                          <li>
                            <a href="/about">{t("Empresa")}</a>
                          </li>
                          <li>
                            <a href="/slate-v-phyllite">{t("La pizarra")}</a>
                          </li>
                          <li>
                            <a href="/product-outside">{t("Producto")}</a>
                          </li>
                          <li>
                            <a href="/contact">{t("Contacto")}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/* End Single Widget  */}
                    {/* Start Single Widget  */}
                    <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                      <div className="footer-link">
                        <h4>{t("Escribenos")}</h4>
                        <ul className="ft-link">
                          <li>
                            <a href="mailto:info@bsslate.com">
                              info@bsslate.com
                            </a>
                          </li>
                        </ul>
                        <br />
                        <h4>{t("Llamanos")}</h4>
                        <ul className="ft-link">
                          <li>
                            <a href="tel:+17866047755">
                              +1 (786) 604 7755 
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/* End Single Widget  */}

                    <div className="col-lg-12">
                      <div className="copyright-text">
                        <p>
                          Copyright © {year} <br />
                          {t("Desarrollo")}{" "}
                          <a
                            href="https://www.linkedin.com/in/sebastianuxcode/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Sebastian Valencia
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default withTranslation()(Footer);
